// crowfy.js: reveal on scroll das seções Crowfy
(function () {
  // Atrasos do centro para fora numa grade de cards (data-cf-stagger): agrupa os cards por linha pela posição real, e em cada
  // linha o do meio entra primeiro e os dos lados logo depois (empate entre os dois lados). As linhas descem em cascata.
  // No celular, com um card por linha, vira uma cascata de cima para baixo.
  function stagger(grid) {
    var cards = Array.prototype.slice.call(grid.children).filter(function (c) { return c.offsetParent !== null; });
    var rows = [];
    cards.forEach(function (card) {
      var top = card.offsetTop;
      var row = rows.filter(function (r) { return Math.abs(r.top - top) < 8; })[0];
      if (!row) { row = { top: top, cards: [] }; rows.push(row); }
      row.cards.push(card);
    });
    rows.sort(function (a, b) { return a.top - b.top; });
    rows.forEach(function (row, rowIndex) {
      var centre = (row.cards.length - 1) / 2;
      var distances = row.cards.map(function (_, i) { return Math.abs(i - centre); });
      var unique = distances.filter(function (d, i) { return distances.indexOf(d) === i; }).sort(function (a, b) { return a - b; });
      row.cards.forEach(function (card, i) {
        var delay = rowIndex * (row.cards.length > 1 ? 140 : 80) + unique.indexOf(distances[i]) * 90;
        card.style.setProperty('--cf-d', delay + 'ms');
      });
    });
  }

  function reveal(el) {
    if (el.hasAttribute('data-cf-stagger')) stagger(el);
    el.classList.add('cf-in');
  }

  function init() {
    var els = document.querySelectorAll('.cf-rv:not(.cf-in)');
    if (!els.length) return;

    // sem o cf-js (JS desligado, movimento reduzido, editor de temas) nada está escondido: só garantir o estado final
    var hidden = document.documentElement.classList.contains('cf-js');
    if (!hidden || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cf-in'); });
      document.documentElement.classList.add('cf-rv-alive');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      // threshold 0 com margem: entra quando o topo do bloco cruza 88% da altura da tela, seja qual for a altura dele.
      // (Com threshold 0.12, um bloco mais alto que ~8 telas, como a grade de cases no celular, nunca chegava a 12% visível.)
      { threshold: 0, rootMargin: '0px 0px -12% 0px' }
    );

    els.forEach(function (el, i) {
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });
    // o observer assumiu a entrada: a rede de segurança do CSS (para o caso de este script não rodar) deixa de valer
    document.documentElement.classList.add('cf-rv-alive');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // reprocessa quando o editor de temas recarrega uma seção
  document.addEventListener('shopify:section:load', init);
})();

// ---------------------------------------------------------------------------
// Timeline do processo: acende os nós e preenche o trilho conforme o scroll
// ---------------------------------------------------------------------------
(function () {
  function initTimelines() {
    var wraps = document.querySelectorAll('.cf-tl:not([data-cf-ready])');
    Array.prototype.forEach.call(wraps, function (wrap) {
      wrap.setAttribute('data-cf-ready', '1');

      var items = wrap.querySelectorAll('.cf-tl__item');
      var fill = wrap.querySelector('.cf-tl__fill');
      if (!items.length || !fill) return;

      if (!('IntersectionObserver' in window)) {
        Array.prototype.forEach.call(items, function (i) { i.classList.add('cf-on'); });
        fill.style.height = '100%';
        return;
      }

      var painting = false;
      function paint() {
        // agrupa leitura e escrita de geometria num único frame:
        // evita o reflow forçado (ler offsetTop logo após mudar classe)
        if (painting) return;
        painting = true;
        requestAnimationFrame(function () {
          painting = false;
          var done = wrap.querySelectorAll('.cf-tl__item.cf-on');
          if (!done.length) { fill.style.height = '0'; return; }
          var last = done[done.length - 1];
          var node = last.querySelector('.cf-tl__node');
          var h = last.offsetTop + (node ? node.offsetTop : 0) + 24;
          fill.style.height = h + 'px';
        });
      }

      var io = new IntersectionObserver(function (entries) {
        var hit = false;
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('cf-on'); hit = true; }
        });
        if (hit) paint();
      }, { threshold: 0.45, rootMargin: '0px 0px -20% 0px' });

      Array.prototype.forEach.call(items, function (i) { io.observe(i); });
    });
  }

  // ---------------------------------------------------------------------------
  // Pipeline: só anima os pontos enquanto a seção estiver visível (poupa CPU)
  // ---------------------------------------------------------------------------
  function initPipelines() {
    var pipes = document.querySelectorAll('.cf-pipe:not([data-cf-ready])');
    Array.prototype.forEach.call(pipes, function (pipe) {
      pipe.setAttribute('data-cf-ready', '1');

      if (!('IntersectionObserver' in window)) {
        pipe.classList.add('cf-live');
        Array.prototype.forEach.call(pipe.querySelectorAll('.cf-pipe__step'), function (s) {
          s.classList.add('cf-on');
        });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { pipe.classList.toggle('cf-live', e.isIntersecting); });
      }, { threshold: 0.15 });
      io.observe(pipe);

      var stepIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('cf-on'); stepIo.unobserve(e.target); }
        });
      }, { threshold: 0.4 });
      Array.prototype.forEach.call(pipe.querySelectorAll('.cf-pipe__step'), function (s) {
        stepIo.observe(s);
      });
    });
  }

  function boot() { initTimelines(); initPipelines(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

// ---------------------------------------------------------------------------
// Chuva Matrix
//
// Regras de performance que este código respeita:
//  1. Só desenha quando a seção está visível (IntersectionObserver).
//  2. Pausa quando a aba perde o foco (visibilitychange).
//  3. Limita os quadros por segundo: 20 fps já parece fluido neste efeito
//     e custa 1/3 do processamento de 60 fps.
//  4. Respeita prefers-reduced-motion (nem inicializa).
//  5. Limita o devicePixelRatio a 1.5: em telas 3x o canvas teria 9x
//     mais pixels para pintar sem ganho visual perceptível.
// ---------------------------------------------------------------------------
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initMatrix() {
    if (reduce) return;

    var canvases = document.querySelectorAll('[data-cf-matrix]:not([data-cf-ready])');

    Array.prototype.forEach.call(canvases, function (canvas) {
      canvas.setAttribute('data-cf-ready', '1');

      var ctx = canvas.getContext('2d', { alpha: false });
      if (!ctx) return;

      var chars = (canvas.getAttribute('data-chars') || '01').split('');
      if (!chars.length) chars = ['0', '1'];

      var color = canvas.getAttribute('data-color') || '#4ce01a';
      var headColor = canvas.getAttribute('data-head') || '#d8ffc4';
      var fontSize = parseInt(canvas.getAttribute('data-size'), 10) || 15;
      var speed = parseInt(canvas.getAttribute('data-speed'), 10) || 5;
      var fps = parseInt(canvas.getAttribute('data-fps'), 10) || 20;
      var opacity = (parseInt(canvas.getAttribute('data-opacity'), 10) || 70) / 100;

      var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      var cols = 0;
      var drops = [];
      var w = 0, h = 0;

      function resize() {
        var rect = canvas.getBoundingClientRect();
        w = Math.max(1, Math.floor(rect.width));
        h = Math.max(1, Math.floor(rect.height));
        canvas.width = Math.floor(w * dpr);
        canvas.height = Math.floor(h * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.font = fontSize + 'px ui-monospace, SFMono-Regular, Menlo, Consolas, monospace';
        ctx.textBaseline = 'top';

        var novo = Math.ceil(w / fontSize);
        if (novo !== cols) {
          cols = novo;
          drops = new Array(cols);
          for (var i = 0; i < cols; i++) {
            // começa em posições aleatórias para não cair tudo alinhado
            drops[i] = Math.random() * -50;
          }
        }
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, w, h);
      }

      function draw() {
        // rastro: retângulo preto translúcido por cima do quadro anterior
        ctx.fillStyle = 'rgba(0, 0, 0, 0.09)';
        ctx.fillRect(0, 0, w, h);

        for (var i = 0; i < cols; i++) {
          var y = drops[i] * fontSize;
          if (y > 0 && y < h + fontSize) {
            var ch = chars[(Math.random() * chars.length) | 0];
            // a primeira letra da coluna é mais clara: dá o efeito de "cabeça"
            ctx.fillStyle = Math.random() > 0.975 ? headColor : color;
            ctx.globalAlpha = opacity;
            ctx.fillText(ch, i * fontSize, y);
            ctx.globalAlpha = 1;
          }
          drops[i] += speed / 10;
          // reinicia a coluna de forma aleatória, evitando ciclo perceptível
          if (y > h && Math.random() > 0.975) drops[i] = 0;
        }
      }

      // ---- laço com limite de fps ----
      var raf = null;
      var last = 0;
      var interval = 1000 / fps;
      var visivel = false;
      var abaAtiva = !document.hidden;

      function loop(ts) {
        raf = requestAnimationFrame(loop);
        if (ts - last < interval) return;
        last = ts;
        draw();
      }

      function play() {
        if (raf || !visivel || !abaAtiva) return;
        last = 0;
        raf = requestAnimationFrame(loop);
      }
      function pause() {
        if (!raf) return;
        cancelAnimationFrame(raf);
        raf = null;
      }

      resize();

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            visivel = e.isIntersecting;
            if (visivel) { play(); } else { pause(); }
          });
        }, { threshold: 0 }).observe(canvas);
      } else {
        visivel = true;
        play();
      }

      document.addEventListener('visibilitychange', function () {
        abaAtiva = !document.hidden;
        if (abaAtiva) { play(); } else { pause(); }
      });

      var t = null;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(resize, 180);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMatrix);
  } else {
    initMatrix();
  }
  document.addEventListener('shopify:section:load', initMatrix);
})();

// ---------------------------------------------------------------------------
// Mapa de frentes e fluxo com ciclo
//  - Mapa: os nós acendem em sequência uma vez, quando o quadro entra na tela.
//  - Fluxo: os pontos só viajam enquanto a seção está visível; as etapas acendem em cascata.
//  Com prefers-reduced-motion as etapas acendem sem animação de ponto (o CSS desliga o resto).
// ---------------------------------------------------------------------------
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initMapsAndFlows() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cf-map]:not([data-cf-ready])'), function (board) {
      board.setAttribute('data-cf-ready', '1');
      var nodes = board.querySelectorAll('.cf-map__node');
      // os pulsos são SMIL e rodam na thread principal: ficam pausados fora da tela (e sempre, com movimento reduzido)
      var svgs = Array.prototype.filter.call(board.querySelectorAll('svg'), function (s) { return s.pauseAnimations; });
      function pulsos(ligar) { svgs.forEach(function (s) { if (ligar) { s.unpauseAnimations(); } else { s.pauseAnimations(); } }); }
      if (reduce) { pulsos(false); return; }
      if (!('IntersectionObserver' in window)) return;
      pulsos(false);
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { pulsos(e.isIntersecting); });
      }, { threshold: 0 }).observe(board);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(board);
          Array.prototype.forEach.call(nodes, function (n, i) {
            setTimeout(function () {
              n.classList.add('cf-on');
              setTimeout(function () { n.classList.remove('cf-on'); }, 900);
            }, 400 + i * 350);
          });
        });
      }, { threshold: 0.4 });
      io.observe(board);
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-cf-flow]:not([data-cf-ready])'), function (flow) {
      flow.setAttribute('data-cf-ready', '1');
      var steps = flow.querySelectorAll('.cf-flow__step');
      if (!('IntersectionObserver' in window)) {
        Array.prototype.forEach.call(steps, function (s) { s.classList.add('cf-on'); });
        return;
      }
      var lit = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!reduce) flow.classList.toggle('cf-live', e.isIntersecting);
          if (!e.isIntersecting || lit) return;
          lit = true;
          Array.prototype.forEach.call(steps, function (s, i) {
            setTimeout(function () { s.classList.add('cf-on'); }, 250 + i * 650);
          });
        });
      }, { threshold: 0.35 });
      io.observe(flow);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMapsAndFlows);
  } else {
    initMapsAndFlows();
  }
  document.addEventListener('shopify:section:load', initMapsAndFlows);
})();

// ---------------------------------------------------------------------------
// Cabeçalho: menu em gaveta quando o menu horizontal não cabe
//  O Horizon só troca para a gaveta (data-menu-style="drawer") em aparelho com toque ou quando o
//  <overflow-list> fica com menos de 2 links visíveis. Aqui o menu está na coluna central, que
//  tem largura automática: a lista nunca transborda, quem transborda é a grade inteira, e sem toque
//  entre 750 e ~1100px o botão "Falar com especialista" e a lupa ficavam fora da tela.
//  Sempre que o Horizon grava "menu" (carregamento, resize, editor), mede-se se logo + menu + lupa +
//  botão cabem na linha; se não cabem, grava "drawer" na mesma tarefa, antes da pintura (sem piscar).
//  A medição é real (getBoundingClientRect), não uma largura fixa. Abaixo de 750px o CSS do Horizon
//  já usa o layout de celular, e com toque o próprio Horizon já escolhe a gaveta: nada muda.
// ---------------------------------------------------------------------------
(function () {
  var desktop = window.matchMedia('(min-width: 750px)');
  var observed = null;
  var observer = null;

  function isTouch() {
    return 'ontouchstart' in window && navigator.maxTouchPoints > 0;
  }

  // quanto o conteúdo da linha de cima passa da margem direita (px); <= 0 significa que cabe
  function overflowAmount(header) {
    var cols = header.querySelector('.header__row--top .header__columns');
    if (!cols) return 0;
    var rect = cols.getBoundingClientRect();
    var limit = rect.right - parseFloat(getComputedStyle(cols).paddingRight || '0');
    var maxRight = -Infinity;
    Array.prototype.forEach.call(cols.querySelectorAll('.header__column > *, header-actions > *'), function (el) {
      var b = el.getBoundingClientRect();
      if (b.width > 0 && b.height > 0 && b.right > maxRight) maxRight = b.right;
    });
    return maxRight === -Infinity ? 0 : maxRight - limit;
  }

  function check(header) {
    if (!desktop.matches || isTouch()) return;
    var list = header.querySelector('overflow-list');
    if (list && list.hasAttribute('minimum-reached')) return;
    // mede sempre no modo menu; a troca e a medição acontecem na mesma tarefa, sem pintura no meio
    if (header.dataset.menuStyle !== 'menu') header.dataset.menuStyle = 'menu';
    if (overflowAmount(header) > 0.5) header.dataset.menuStyle = 'drawer';
  }

  function init() {
    var header = document.getElementById('header-component');
    if (!header || header === observed) return;
    if (observer) observer.disconnect();
    observed = header;
    observer = new MutationObserver(function () {
      // reage só quando o Horizon decidiu "menu"; "drawer" (toque ou gravado aqui) fica como está
      if (header.dataset.menuStyle === 'menu') check(header);
    });
    observer.observe(header, { attributes: true, attributeFilter: ['data-menu-style'] });
    if (header.dataset.menuStyle === 'menu') check(header);

    // No carregamento a largura final só aparece depois: o <overflow-list> espera o próprio CSS e
    // as fontes mudam a largura dos links. Mede de novo quando o menu ou o botão mudam de tamanho
    // (no quadro seguinte, para não gerar aviso de loop do ResizeObserver).
    if ('ResizeObserver' in window) {
      var pending = false;
      var ro = new ResizeObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          if (header.dataset.menuStyle === 'menu') check(header);
        });
      });
      Array.prototype.forEach.call(header.querySelectorAll('.header__row--top header-menu, .header__row--top header-actions'), function (el) {
        ro.observe(el);
      });
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (header.dataset.menuStyle === 'menu') check(header);
      });
    }
  }

  var timer;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (observed) check(observed);
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

// crowfy.js: faixa rolante com arraste e inércia (melhoria progressiva sobre a animação CSS)
//  - Só liga com data-drag e sem prefers-reduced-motion; fora disso a animação CSS continua valendo.
//  - Velocidade = metade da largura (um conjunto de itens) por duração configurada, em px por quadro.
//  - Arraste: velocidade = dx/dt * 16, decaimento 0.95; abaixo de 0.1 volta ao movimento automático.
//  - Só desenha com a faixa visível e para quando o elemento sai do DOM.
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    var track = root.querySelector('.cf-marq__track');
    if (!track || root.dataset.dragReady) return;
    root.dataset.dragReady = '1';
    root.classList.add('is-drag');

    var offset = 0, velocity = 0, dragging = false, startX = 0, startOffset = 0, lastX = 0, lastT = 0;
    var visible = true, raf = 0;
    var seconds = parseFloat(root.dataset.duration) || 34;

    function frame() {
      if (!root.isConnected) return;
      var half = track.scrollWidth / 2;
      if (visible && half > 0) {
        if (!dragging) {
          if (Math.abs(velocity) > 0.1) {
            offset += velocity;
            velocity *= 0.95;
          } else {
            velocity = 0;
            offset -= half / (seconds * 60);
          }
        }
        if (offset <= -half) offset += half;
        if (offset > 0) offset -= half;
        track.style.transform = 'translate3d(' + offset + 'px,0,0)';
      }
      raf = requestAnimationFrame(frame);
    }

    root.addEventListener('pointerdown', function (e) {
      dragging = true;
      velocity = 0;
      startX = lastX = e.clientX;
      startOffset = offset;
      lastT = performance.now();
      root.classList.add('is-grabbing');
      try { root.setPointerCapture(e.pointerId); } catch (err) {}
    });
    root.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var now = performance.now();
      velocity = ((e.clientX - lastX) / Math.max(now - lastT, 1)) * 16;
      lastX = e.clientX;
      lastT = now;
      offset = startOffset + (e.clientX - startX);
    });
    function end() {
      dragging = false;
      root.classList.remove('is-grabbing');
    }
    root.addEventListener('pointerup', end);
    root.addEventListener('pointercancel', end);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }).observe(root);
    }
    raf = requestAnimationFrame(frame);
  }

  function init() {
    if (reduce) return;
    document.querySelectorAll('.cf-marq[data-drag]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

// crowfy.js: esqueleto com brilho nas imagens dos cases enquanto carregam
(function () {
  function init() {
    document.querySelectorAll('.cf-case__img img').forEach(function (img) {
      if (img.complete) return;
      var box = img.parentNode;
      box.classList.add('is-loading');
      function done() { box.classList.remove('is-loading'); }
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

// crowfy.js: rolagem da captura do site nos cards de cases em telas de toque (no mouse é só CSS, no hover).
// Rola uma vez quando o card fica visível e volta ao topo depois; não liga com prefers-reduced-motion.
(function () {
  var touch = window.matchMedia && !window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    if (!touch || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var box = entry.target;
        io.unobserve(box);
        box.classList.add('is-auto');
        setTimeout(function () { box.classList.remove('is-auto'); }, 6500);
      });
    }, { threshold: 0.6 });
    document.querySelectorAll('.cf-case__img--scroll:not([data-scroll-ready])').forEach(function (box) {
      box.setAttribute('data-scroll-ready', '');
      io.observe(box);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

// crowfy.js: inclinação leve dos cards de cases com inércia (ideia do prompt Animated Cards do motionsites).
// Só com mouse, tela larga e sem movimento reduzido (a mesma condição do CSS). O laço de quadros roda só enquanto o card
// ainda não chegou ao ângulo do mouse e para sozinho quando assenta: nada fica rodando fora do hover.
(function () {
  var mq = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px) and (prefers-reduced-motion: no-preference)');
  var MAX = 3.5; // graus

  function bind(card) {
    if (card.hasAttribute('data-tilt-ready')) return;
    card.setAttribute('data-tilt-ready', '');
    var tx = 0, ty = 0, x = 0, y = 0, raf = 0, over = false;

    function tick() {
      x += (tx - x) * 0.14;
      y += (ty - y) * 0.14;
      card.style.setProperty('--cf-rx', y.toFixed(2) + 'deg');
      card.style.setProperty('--cf-ry', x.toFixed(2) + 'deg');
      if (Math.abs(tx - x) > 0.02 || Math.abs(ty - y) > 0.02) {
        raf = requestAnimationFrame(tick);
        return;
      }
      raf = 0;
      if (!over) {
        card.classList.remove('is-tilt');
        card.style.removeProperty('--cf-rx');
        card.style.removeProperty('--cf-ry');
      }
    }
    function start() { if (!raf) raf = requestAnimationFrame(tick); }

    card.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !mq.matches) return;
      over = true;
      card.classList.add('is-tilt');
    });
    card.addEventListener('pointermove', function (e) {
      if (!over) return;
      var r = card.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 2 * MAX;
      ty = -((e.clientY - r.top) / r.height - 0.5) * 2 * MAX;
      start();
    });
    card.addEventListener('pointerleave', function () {
      if (!over) return;
      over = false;
      tx = 0;
      ty = 0;
      start();
    });
  }

  function init() {
    if (!mq || !mq.matches) return;
    document.querySelectorAll('.cf-case').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
